/* global jQuery COMPONENTS */

COMPONENTS.ComponentSpecials2 = (function ($) {
  function ComponentSpecials2 () {
    this.$component = $('[data-ecs-component="component-specials"]')
    this.$ComponentSpecials2Buttons = $('[data-src="#components-specials-specials"]').first()
    this.$anchors = $('a')
    this.$onLoad = $( '[data-specials-open-on-load="1"]' )
  }

  ComponentSpecials2.prototype.init = function () {
    const component = this

    component.$anchors.each(function () {
      // Set a scoped reference to the anchor and href
      const $anchor = $(this)
      // If it doesn't have an href make sure to pass along an empty string
      // to the rest of the function below to prevent undefined errors
      const href = ($anchor.attr('href') ? $anchor.attr('href') : '')

      // Handle fancybox inline content
      if (href.includes('#components-specials')) {
        const link = href
        $anchor.attr('data-fancybox', '')
        $anchor.attr('data-src', link)
        $anchor.attr('href', 'javascript:;')
      }
    })
    console.log('Onload Specials Components:', component.$onLoad)

    component.$onLoad.each(function () {
      const id = $(this).attr('id')
      $.fancybox.open({
        src: id ? `#${id}` : '#components-specials-specials',
        type: 'inline',
      })
    })

  }

  return ComponentSpecials2
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.ComponentSpecials2 = new COMPONENTS.ComponentSpecials2()
  COMPONENTS.ComponentSpecials2.init()
})
